"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.of = void 0;

var _ArrayObservable = require("./ArrayObservable");

var of = _ArrayObservable.ArrayObservable.of;
exports.of = of;